import * as types from '../../actions/actionsTypes/giustificativiActionType';
import {printOnlyInDevelopment} from "../../fanctionUtility";

export const initialStateTipiGiustificativi = {
    tipiGiustificativi: [],
    allGiustificativi : [],
    valoreAggiornato : null,
    nuovoGiustificativo : null,
    errori: []
};

export const tipiGiustificativiReducer = ( state = initialStateTipiGiustificativi, action ) => {

    switch (action.type){

        case types.INIT_TIPI_GIUSTIFICATIVI: {
            return{
                tipiGiustificativi: [],
                allGiustificativi : [],
                valoreAggiornato : null,
                nuovoGiustificativo : null,
                errori: []
            };
        }

        case types.GET_TIPI_GIUSTIFICATIVI_BY_TIPO_CORSO_SUCCESS: {
            printOnlyInDevelopment('Tipi Giustificativi payload :: ', action.giustificativi);
            return {
                ...state,
                tipiGiustificativi: action.giustificativi
            };
        }

        case types.GET_TIPI_GIUSTIFICATIVI_BY_TIPO_CORSO_FAIL: {
            printOnlyInDevelopment( 'Tipi Giustificativi error :: ', action.giustificativiError );
            return {
                ...state,
                errori: action.giustificativiError
            };
        }

        case types.GET_ALL_TIPI_GIUSTIFICATIVI_SUCCESS : {
            printOnlyInDevelopment( 'Recupero di tutti i Giustificativi :: ', action.tipiGiustificativi );
            return {
                ...state,
                allGiustificativi : action.tipiGiustificativi
            }
        }

        case types.GET_ALL_TIPI_GIUSTIFICATIVI_FAIL : {
            printOnlyInDevelopment( 'Errore durante il recupero di tutti i Giustificativi :: ', action.error );
            return {
                ...state,
                error : action.error
            }
        }

        case types.UPDATE_SUCCESS : {
            return {
                ...state,
                valoreAggiornato : action.giustificativoUpdated
            };
        }

        case types.INSERT_TIPO_GIUSTIFICATIVO_SUCCESS : {
            return {
                ...state,
                nuovoGiustificativo : action.nuovoGiustificativo
            }
        }

        case types.INIT_UPDATE_FIELDS : {
            if ( state.valoreAggiornato || state.nuovoGiustificativo ) {
                return {
                    ...state,
                    valoreAggiornato : null,
                    nuovoGiustificativo : null
                }
            } else {
                return state;
            }
        }

        default:
            return state
    }
};

